import React from 'react';
import Modal from 'react-modal';
import { Button, Icon, Alert } from "tabler-react";

const ModalCancelacionServicio = ({
  isOpen,
  onClose,
  servicio,
  tieneGPS,
  onConfirmar,
  cargando = false
}) => {
  
  if (!servicio) return null;

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Cancelar Servicio"
      className="Modal"
      style={{
        overlay: { 
          display: "block",
          zIndex: 10001,
          backgroundColor: 'rgba(0, 0, 0, 0.75)'
        },
        content: {
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          height: "auto",
          margin: "0",
          zIndex: 10002,
          borderRadius: "8px",
          border: "1px solid #ccc",
          background: "#fff",
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          outline: "none",
          padding: "0"
        }
      }}
    >
      <div className="modal-content">
        <div className="modal-header" style={{ 
          padding: "15px 20px", 
          borderBottom: "1px solid #e9ecef",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <h4 className="modal-title" style={{ margin: 0, display: "flex", alignItems: "center" }}>
            <Icon name="alert-triangle" className="text-warning mr-2" />
            Cancelar Servicio
          </h4>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={onClose}
            style={{ border: "none", background: "none", fontSize: "18px" }}
          >
            <Icon name="x" />
          </button>
        </div>
        
        <div className="modal-body" style={{ padding: "20px" }}>
          <div className="mb-3">
            <strong>ID del Servicio:</strong> 
            <span className="ml-2 badge badge-primary">{servicio.idSolicitud}</span>
          </div>
          
          <div className="mb-3">
            <strong>Cliente:</strong> 
            <span className="ml-2">{servicio.idCliente?.nombre || 'No especificado'}</span>
          </div>
          
          <div className="mb-3">
            <strong>Contenedor:</strong> 
            <span className="ml-2">{servicio.contenedor || 'No especificado'}</span>
          </div>

          {servicio.idTransportista && (
            <div className="mb-3">
              <strong>Transportista:</strong> 
              <span className="ml-2">{servicio.idTransportista.nombre}</span>
            </div>
          )}
          
          {tieneGPS ? (
            <Alert type="warning" hasExtraSpace>
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Icon name="alert-triangle" className="text-warning mr-2 mt-1" />
                <div>
                  <strong>Atención: Este servicio cuenta un GPS asignado.</strong>
                  <br />
                  Al cancelar se aplicará un cargo por el equipo GPS (servicio en falso) del 40% siempre y cuando no  haya salido de la localidad
                  de lo contrario, el servicio sera cobrado al 100%.
                </div>
              </div>
            </Alert>
          ) : (
            <Alert type="info" hasExtraSpace>
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Icon name="info" className="text-info mr-2 mt-1" />
                <div>
                  <strong>Información:</strong> Este servicio no tiene GPS asignado. 
                  No se aplicarán cargos adicionales por cancelación.
                </div>
              </div>
            </Alert>
          )}
          
          <div className="text-center mt-4 p-3" style={{ 
            backgroundColor: "#f8f9fa", 
            borderRadius: "4px",
            border: "1px solid #dee2e6"
          }}>
            <p style={{ margin: 0, fontWeight: "bold", color: "#495057" }}>
              ¿Está seguro de que desea cancelar este servicio?
            </p>
            {tieneGPS && (
              <small className="text-muted">
                Esta acción no se puede deshacer y se aplicarán los cargos correspondientes.
              </small>
            )}
          </div>
        </div>
        
        <div className="modal-footer" style={{ 
          padding: "15px 20px", 
          borderTop: "1px solid #e9ecef",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px"
        }}>
          <Button
            color="secondary"
            onClick={onClose}
            disabled={cargando}
          >
            <Icon name="x" className="mr-1" />
            Cancelar
          </Button>
          <Button
            color="danger"
            onClick={onConfirmar}
            disabled={cargando}
          >
            {cargando ? (
              <>
                <Icon name="loader" className="mr-1" />
                Procesando...
              </>
            ) : (
              <>
                <Icon name="check" className="mr-1" />
                Confirmar Cancelación
              </>
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalCancelacionServicio;
